<csl-service-image [serviceCode$$]="serviceCode$$()" [isCollapsed$$]="isCollapsed$$()" class="bg-gray-100">
  <div class="flex justify-between">
    <div>
      <h3 class="mb-1 text-base font-bold md:text-lg">{{ serviceType$$() }}</h3>
      <p class="text-gray-750 text-xs">{{ serviceDescription$$() }}</p>
    </div>
    @if (isCollapsedIconVisible$$()) {
      <i
        class="block h-6 w-6 min-w-6 bg-[url(../assets/icons/dropdown-arrow.svg)]"
        (click)="toggleCollapse()"
        [class.rotate-180]="!isCollapsed$$()"
      ></i>
    }
  </div>
  <div [class.hidden]="isCollapsed$$()" class="text-xs text-blue-900">
    @for (desc of serviceDetailsDescription$$(); track $index; let last = $last) {
      <div class="flex items-start gap-1" [class.mb-1]="!last">
        <i class="g-filter-green-600 -mt-0.5 block h-4 w-4 min-w-4 bg-[url(../assets/icons/checkmark.svg)]"></i>
        <div>{{ desc }}</div>
      </div>
    }
  </div>
</csl-service-image>
